import { render, staticRenderFns } from "./ExamForm.vue?vue&type=template&id=baa261e2&scoped=true"
import script from "./ExamForm.vue?vue&type=script&lang=js"
export * from "./ExamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa261e2",
  null
  
)

export default component.exports